import React, { useState } from "react";
import { InfoCard, Input, PrimaryButton, TextArea } from "best-common-react";

const CustomerIdSearch = params => {
  const [email, setEmail] = useState("");
  const [result, setResult] = useState("");

  const search = email => {
    params.compTixApi.searchCustomer(params.dsn, email).then(res => {
      setResult(res.length ? res : "Not found");
    });
  };

  return (
    <InfoCard className="mt-2" title="Customer Search" backgroundColor="white">
      <div className="d-flex flex-row my-2">
        <div className="d-flex flex-column col-6">
          <Input type="text" onChange={v => setEmail(v.target.value)} />
        </div>
        <PrimaryButton onClick={() => search(email)}>Search</PrimaryButton>
      </div>
      <div className="d-flex flex-row my-2 ml-2">
        <InfoCard backgroundColor="white" name="Customer Id">
          {`Customer Ids for DSN ${params.dsn}: ${result}`}
        </InfoCard>
      </div>
    </InfoCard>
  );
};

export default CustomerIdSearch;
